// extracted by mini-css-extract-plugin
export default {"post":"Posts_post__X6pyF","title":"Posts_title__FCVIQ","info":"Posts_info__uZpMG","author":"Posts_author__WfE66"};